import getQueryByName from './query'

const initialState = {
    lastSlide: -1,
    activeSlide: 0,
    slides: [],
    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    lang: '',
    disclaimer: '',
    drawerItems: []
}

export default function reducer(state = initialState, action) {
    switch(action.type) {
        case 'SET_LANG':
            return { ...state, lang: action.lang }
        case 'SET_SLIDES':
            return { ...state, slides: action.slides }
        case 'SET_DRAWER_ITEMS':
            return { ...state, drawerItems: action.items }
        case 'SET_DISCLAIMER':
            return { ...state, disclaimer: action.disclaimer }
        case 'CHANGE_ACTIVE_SLIDE':
            return { ...state, lastSlide: state.activeSlide, activeSlide: Math.min(Math.max(action.slide, 0), state.slides.length - 1) }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer.js